import { render, staticRenderFns } from "./applyOfStudent.pug?vue&type=template&id=20043397&lang=pug&"
import script from "./applyOfStudent.ts?vue&type=script&lang=ts&"
export * from "./applyOfStudent.ts?vue&type=script&lang=ts&"
import style0 from "./applyOfStudent.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports